import React, { useState, useEffect } from "react";
import { FormGroup } from "@mui/material";
import { Search as SearchIcon } from "@mui/icons-material";
import useStyles from "./styles";
import { useTranslation } from "react-i18next";

import Input from "../../Form/Input";
import Checkbox from "../../Form/Checkbox";

type CheckboxItem = {
  id: number;
  name: string;
};

type Props = {
  data?: CheckboxItem[];
  onSelectItem: (itemId: number, isItemSelected: boolean) => void;
};

const MultipleSelection = ({ data, onSelectItem }: Props) => {
  const classes = useStyles();
  const { t: translate } = useTranslation();

  const [search, setSearch] = useState<string>("");
  const [filteredData, setFilteredData] = useState<CheckboxItem[]>([]);
  const [selectedItems, setSelectedItems] = useState<number[]>([]);

  useEffect(() => {
    const filteredDataAux: CheckboxItem[] =
      data?.filter(item =>
        item.name.toLowerCase().includes(search.toLowerCase())
      ) || [];
    setFilteredData(filteredDataAux);
  }, [search]);

  return (
    <div className={classes.mainDiv}>
      <Input
        fullWidth
        className={classes.searchBar}
        id="searchbar-listselection"
        label={translate("search")}
        value={search}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
          setSearch(event.target.value)
        }
        rightIcon={<SearchIcon />}
      />
      <div>
        {filteredData && filteredData.length > 0 ? (
          <FormGroup>
            {filteredData.map((item, index: number) => (
              <Checkbox
                className="mb-3"
                key={item.id}
                checked={selectedItems && selectedItems.includes(item.id)}
                onChange={(_, checked) => {
                  const checks = selectedItems;
                  if (checked) checks[index] = item.id;
                  else checks[index] = -1;

                  setSelectedItems([...checks]);
                  onSelectItem(item.id, checked);
                }}
                label={item.name}
              />
            ))}
          </FormGroup>
        ) : (
          <span className={classes.labelNotFound}>
            {translate("noItemFound")}
          </span>
        )}
      </div>
    </div>
  );
};

export default MultipleSelection;
